import { Fragment, useEffect } from "react";
import { Row, Col, NavDropdown, Container, Navbar, Nav, DropdownDivider } from "react-bootstrap";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import { Helmet } from "react-helmet";

import { useTranslation } from 'react-i18next';

import LangSelector, { langSelector } from './LangSelector.jsx';

import CookieConsentPopup from './CookieConsentPopup.jsx';

import "../../../../../css/web/bedloop1/styles.css";

const stripHtml = (html) => {
    return html.replace(/<[^>]*>/g, '');
};

const Menu = ({ destinos, sobrenosotros, clientes, propietarios, servicios, experiencias, idiomas, lang, tiposcasas, config, textopropiedades, edificios, marcas, ruta, destinoslarga, meta_titulo, meta_descripcion, meta_keywords, numblog, numfaqs, paginapersonalizada }) => {

    // Color de marca del tenant com a variable CSS a <html>: les animacions i
    // ressaltats (Detalles, comptador d'extres, "Ver mi reserva"...) el fan
    // servir via var(--corporatiu).
    useEffect(() => {
        if (config.color_corporativo_web) {
            document.documentElement.style.setProperty('--corporatiu', config.color_corporativo_web);
        }
    }, [config.color_corporativo_web]);
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const primeraLetraMayuscula = (cadena) => cadena.charAt(0).toUpperCase().concat(cadena.substring(1, cadena.length).toLowerCase());

    useEffect(() => {
        if (config.css_personalizado) {
            const linkElement = document.createElement('link');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = config.css_personalizado;
            const headElement = document.head;
            headElement.appendChild(linkElement);
        }

    }, []);

    const descripcionLimpia = meta_descripcion ? stripHtml(meta_descripcion) : "";
    const keywordsLimpias = meta_keywords ? stripHtml(meta_keywords) : "";


    const handleCookieAccept = () => {
        console.log('Cookies aceptadas');
        // Inicializar Google Analytics, etc.
    };

    const handleCookieReject = () => {
        console.log('Cookies rechazadas');
        // No cargar scripts de tracking
    };

    const handleCookieConfigure = () => {
        console.log('Abrir configuración detallada');
        // Lógica para modal avanzado
    };

    return (
        <>
            <Helmet>
                <title>{`${((typeof window !== "undefined" && window.__SEO__?.title) || meta_titulo)}`}</title>
                <meta name="title" content={`${((typeof window !== "undefined" && window.__SEO__?.title) || meta_titulo)}`} />
                <meta name="description" content={(typeof window !== "undefined" && window.__SEO__?.description) || (descripcionLimpia)} />
                <meta name="keywords" content={keywordsLimpias} />
                <meta charset="utf-8" />
            </Helmet>

            {
                (config.id === 1) ?
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/favicon.ico`}></link>
                    </Helmet>
                    :
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/${config.id}/favicon.ico`}></link>
                    </Helmet>
            }

            {/*
                (config.activa_analytics === 1) ?
                    <Helmet>
                        <script async src={`https://www.googletagmanager.com/gtag/js?id=${config.codigo_analytics}`}></script>
                        <script>
                            {`
                                window.dataLayer = window.data          }Layer || [];
                                function gtag(){window && window.dataLayer && window.dataLayer.push(arguments)}
                                gtag('js', new Date())
                                gtag('config', '${config.codigo_analytics}');
                            `}          }
                        </script>           }
                    </Helmet>           }
                    :
                    ""
            */}

            {
                (config.activa_analytics === 1) ?
                    <Helmet>
                        <script>
                            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.codigo_analytics}');
                            `}
                        </script>
                    </Helmet>
                    :
                    ""
            }

            {
                (config.activa_analytics === 1) ?
                    <noscript>
                        {`<iframe src="https://www.googletagmanager.com/ns.html?id=${config.codigo_analytics}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
                    </noscript>
                    :
                    ""
            }

            <CookieConsentPopup
                onAccept={handleCookieAccept}
                onReject={handleCookieReject}
                onConfigure={handleCookieConfigure}
                policyUrl={preidioma + t("cookies")}
            />

            <Navbar collapseOnSelect expand="lg" className="bg-body menu sticky-top">
                <Navbar.Brand href={`/${preidioma}`}>
                    {
                        config.logo !== "" ?
                            <img className="logo logobl1" alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                            :
                            config.logo_fiscal != "" ?
                                <img className="logo logobl1" alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                :
                                <img className="logo logobl1" alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                    }
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link className="navegacio" href={`/${preidioma}`}>{t("Inicio")}</Nav.Link>
                        {destinos.length > 1 ?
                            <NavDropdownMenu className="navegacio" title={t("Alquiler turístico")} id="collasible-nav-dropdown" >
                                {destinos.map((undestino, index) => (
                                    <Fragment key={"dest" + index}>
                                        {undestino.barrios.length > 0 ?
                                            <>
                                                <DropdownSubmenu
                                                    title={undestino.elnombre}
                                                >
                                                    <NavDropdown.Item href={"/" + preidioma + t("apartamentos") + "-" + undestino.laurl} key={"d" + index}>
                                                        {t("Todos")}
                                                    </NavDropdown.Item>
                                                    <DropdownDivider></DropdownDivider>
                                                    <div className="columna">
                                                        {undestino.barrios.map((unbarrio, index2) => (
                                                            unbarrio.cuantaspub > 0 ?
                                                                <NavDropdown.Item href={"/" + preidioma + t("barrio") + "-" + unbarrio.nombre[lang]} key={"b" + index2} className="barriomenu">{unbarrio.nombre[lang]}</NavDropdown.Item>
                                                                :
                                                                ""
                                                        ))}
                                                    </div>
                                                </DropdownSubmenu>
                                            </>
                                            :
                                            <>
                                                <NavDropdown.Item className="navegacio" href={"/" + preidioma + t("apartamentos") + "-" + undestino.laurl} key={index}>{undestino.elnombre}</NavDropdown.Item>
                                            </>
                                        }
                                    </Fragment>
                                ))}
                            </NavDropdownMenu>
                            :
                            destinos[0].barrios.length > 0 ?
                                <NavDropdownMenu className="navegacio" title={destinos[0].elnombre} id="collasible-nav-dropdown" >
                                    <>
                                        <NavDropdown.Item href={"/" + preidioma + t("apartamentos") + "-" + destinos[0].laurl} >{t("Todos")}</NavDropdown.Item>
                                        <DropdownDivider></DropdownDivider>
                                        <div className="columna">
                                            {destinos[0].barrios.map((unbarrio, index) => (
                                                unbarrio.cuantaspub > 0 ?
                                                    <NavDropdown.Item href={"/" + preidioma + t("barrio") + "-" + unbarrio.nombre[lang]} key={"bs" + index} className="barriomenu">{unbarrio.nombre[lang]}</NavDropdown.Item>
                                                    :
                                                    ""
                                            ))}
                                        </div>
                                    </>
                                </NavDropdownMenu>
                                :
                                <Nav.Link className="navegacio" href={"/" + preidioma + t("apartamentos") + "-" + destinos[0].laurl}>{destinos[0].elnombre}</Nav.Link>
                        }
                        {edificios.length > 0 ?
                            edificios.length > 1 ?
                                <NavDropdown className="navegacio" title={t("Edificios")} id="collasible-nav-dropdown-exp">
                                    {edificios.map((edificio, index) => (
                                        <NavDropdown.Item href={"/" + preidioma + t("edificio") + "/" + edificio.url_dinamica} key={"e" + index}>{edificio.nombre}</NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                                :
                                <Nav.Link className="navegacio" href={"/" + preidioma + t("edificio") + "/" + edificios[0].url_dinamica}>{edificios[0].nombre}</Nav.Link>
                            : ""
                        }
                        {destinoslarga.length > 0 ?
                            destinoslarga.length == 1 ?
                                <Nav.Link className="navegacio" href={"/" + preidioma + t("alquilertemporada") + "-" + destinoslarga[0].laurl}>{t("Alquiler temporada")}</Nav.Link>
                                :
                                <NavDropdown className="navegacio" title={t("Alquiler temporada")} id="collasible-nav-dropdown-dest">
                                    {destinoslarga.map((undestino, index) => (
                                        <NavDropdown.Item href={"/" + preidioma + t("alquilertemporada") + "-" + undestino.laurl} key={"dl" + index}>{undestino.elnombre}</NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                            : ""
                        }
                        {marcas.length > 0 ?
                            marcas.length > 1 ?
                                <NavDropdown className="navegacio" title={t("Marcas")} id="collasible-nav-dropdown-exp">
                                    {marcas.map((marca, index) => (
                                        <NavDropdown.Item href={"/" + preidioma + t("marca") + "/" + marca.nombre} key={"m" + index}>{marca.nombre}</NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                                :
                                <Nav.Link className="navegacio" href={"/" + preidioma + t("marca") + "/" + marcas[0].nombre}>{marcas[0].nombre}</Nav.Link>
                            : ""
                        }
                        {experiencias.length > 0 ?
                            <NavDropdown className="navegacio" title={t("Experiencias")} id="collasible-nav-dropdown-exp">
                                {experiencias.map((experiencia, index) => (
                                    <NavDropdown.Item href={"/" + preidioma + t("experiencias") + "/" + experiencia.url_dinamica[lang]} key={"e" + index}>{experiencia.nombre[lang]}</NavDropdown.Item>
                                ))}
                            </NavDropdown>
                            : ""
                        }
                        {tiposcasas.length > 1 ?
                            <NavDropdown className="navegacio" title={t("Tipo_Alojamiento")} id="collasible-nav-dropdown-tipo">
                                <NavDropdown.Item href={"/" + preidioma + t("buscar")}>{t("Todos")}</NavDropdown.Item>
                                {tiposcasas.map((tipocasa, index) => (
                                    <NavDropdown.Item href={"/" + preidioma + t("buscar") + "?tipo_casa=" + tipocasa.id} key={"tc" + index}>{primeraLetraMayuscula(t(tipocasa.nombre))}</NavDropdown.Item>
                                ))}
                            </NavDropdown>
                            : ""
                        }
                        {
                            numblog > 0 ?
                                <Nav.Link className="navegacio" href={"/" + preidioma + t("blog")}>{t("Blog")}</Nav.Link>
                                :
                                ""
                        }

                        {paginapersonalizada && paginapersonalizada.en_menu_empresa === 0 ?
                            paginapersonalizada.amigable_o_externa === 1 ?
                                <Nav.Link className="navegacio" href={"/" + preidioma + "web-" + paginapersonalizada.laurldinamica}>{paginapersonalizada.eltitulo}</Nav.Link>
                                :
                                <Nav.Link className="navegacio" href={paginapersonalizada.laurlexterna}>{paginapersonalizada.eltitulo}</Nav.Link>
                            :
                            ""
                        }

                        {((sobrenosotros.ladesc !== null && sobrenosotros.ladesc !== "" && sobrenosotros.ladesc !== "<p>&nbsp;</p>") || (clientes.ladesc !== null && clientes.ladesc !== "" && clientes.ladesc !== "<p>&nbsp;</p>") || (propietarios.ladesc !== null && propietarios.ladesc !== "" && propietarios.ladesc !== "<p>&nbsp;</p>") || numfaqs > 0 || (servicios.ladesc !== null && servicios.ladesc !== "" && servicios.ladesc !== "" && servicios.ladesc !== "<p>&nbsp;</p>") || (textopropiedades.ladesc !== null && textopropiedades.ladesc !== "" && textopropiedades.ladesc !== "<p>&nbsp;</p>") || (paginapersonalizada && paginapersonalizada.en_menu_empresa === 1)) ?
                            <NavDropdown className="navegacio" title={t("Empresa")} id="collasible-nav-dropdown-empresa">
                                {sobrenosotros.ladesc !== null && sobrenosotros.ladesc !== "" && sobrenosotros.ladesc !== "<p>&nbsp;</p>" ? <NavDropdown.Item href={"/" + preidioma + t("sobre-nosotros")}>{t("Sobre_Nosotros")}</NavDropdown.Item> : ''}
                                {clientes.ladesc !== null && clientes.ladesc !== "" && clientes.ladesc !== "<p>&nbsp;</p>" ? <NavDropdown.Item href={"/" + preidioma + t("clientes")}>{t("Clientes")}</NavDropdown.Item> : ''}
                                {propietarios.ladesc !== null && propietarios.ladesc !== "" && propietarios.ladesc !== "<p>&nbsp;</p>" ? <NavDropdown.Item href={"/" + preidioma + t("propietarios")}>{t("Propietarios")}</NavDropdown.Item> : ''}
                                {numfaqs > 0 ? <NavDropdown.Item href={"/" + preidioma + "faqs"}>FAQ's</NavDropdown.Item> : ""}
                                {servicios.ladesc !== null && servicios.ladesc !== "" && servicios.ladesc !== "" && servicios.ladesc !== "<p>&nbsp;</p>" ? <NavDropdown.Item href={"/" + preidioma + t("servicios")}>{t("Servicios")}</NavDropdown.Item> : ''}
                                {textopropiedades.ladesc !== null && textopropiedades.ladesc !== "" && textopropiedades.ladesc !== "<p>&nbsp;</p>" ? <NavDropdown.Item href={"/" + preidioma + t("propiedades")}>{t("Propiedades")}</NavDropdown.Item> : ''}

                                {paginapersonalizada && paginapersonalizada.en_menu_empresa === 1 ?
                                    paginapersonalizada.amigable_o_externa === 1 ?
                                        <NavDropdown.Item href={"/" + preidioma + paginapersonalizada.laurldinamica}>{paginapersonalizada.eltitulo}</NavDropdown.Item>
                                        :
                                        <NavDropdown.Item href={paginapersonalizada.laurlexterna}>{paginapersonalizada.eltitulo}</NavDropdown.Item>
                                    :
                                    ""
                                }
                            </NavDropdown>
                            :
                            ""
                        }


                        <NavDropdown className="navegacio" title={t("Ayuda")} id="collasible-nav-dropdown.ayuda">
                            <Container className="mt-1 mb-1 ajuda">
                                <Row className="ml-5">
                                    <Col xs="12" md="12" sm="6" className="mt-3">
                                        <p className="bold">{t("¿Alguna pregunta? ¡Hablemos!")}</p>
                                    </Col>
                                    <Col xs="12" md="12" sm="6">
                                        <i className="fa-duotone fa-square-phone"></i> <a href={"tel:" + config.telefono_fiscal}>{config.telefono_fiscal}</a><br /><br />
                                        <i className="fa-duotone fa-square-envelope" aria-hidden="true"></i><a href={"mailto:" + config.email_fiscal}> {config.email_fiscal}</a><br /><br />
                                        <a href="#"><i className="fa-duotone fa-location-dot" aria-hidden="true"></i> {config.direccion_fiscal + ", " + config.codigo_postal_fiscal + ", " + config.poblacion_fiscal}</a><br /><br />
                                        <a className="btn btn-danger" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web }} href={"/" + preidioma + t("contacto")}>{t("Contáctanos")}</a>
                                    </Col>
                                </Row>
                            </Container>
                        </NavDropdown>
                        <Nav.Link className="navegacio" href={"/" + preidioma + t("formgestionareserva")}>{t("Gestiona tu reserva")}</Nav.Link>
                        <LangSelector
                            idiomas={idiomas}
                            langactual={lang.toString().toUpperCase()}
                        />
                        {/*<Nav.Link className="navegacio" href="/loginweb">{ t("Login") }</Nav.Link>*/}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    );
}

export default Menu;
